import Box from '@component/Box';
import Image from '@component/Image';
import { useAppContext } from '@context/app/AppContext';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { CartApi } from 'pages/api';
import React, { useCallback } from 'react';
import { SpaceProps } from 'styled-system';
import Button from '../buttons/Button';
import IconButton from '../buttons/IconButton';
import FlexBox from '../FlexBox';
import Icon from '../icon/Icon';
import Typography from '../Typography';
import { StyledProductCard7 } from './ProductCardStyle';

export interface ProductCard7Props {
  id: string | number;
  name: string;
  qty: number;
  price: number;
  imgUrl?: { fileUrl: string };
}

const ProductCard7: React.FC<ProductCard7Props & SpaceProps> = ({
  id,
  name,
  qty,
  price,
  imgUrl,
  ...props
}) => {
  const { data: session, status } = useSession();
 const loading = status === 'loading';;
  const token = session?.accessToken.toString();
  const router = useRouter()

  const { dispatch } = useAppContext();
  const handleCartAmountChange = useCallback(
    (amount) => () => {
      dispatch({
        type: 'CHANGE_CART_AMOUNT',
        payload: {
          qty: amount,
          name,
          price,
          imgUrl,
          id,
        },
      });
    },
    []
  );

  const removeItemFromCart = async (listingId) => {
    try {
      const resp = await CartApi.removeFromCart(token, listingId);
      if (resp.status === 200) {
        dispatch({
          type: 'CHANGE_CART_AMOUNT',
          payload: {
            qty: 0,
            name,
            price,
            imgUrl,
            id,
          },
        });
        // navigate to home screen
        router.push('/')
      }
    } catch (err) {
      console.log('error removing item from cart', err);
    }
  };

  return (
    <StyledProductCard7 {...props}>
      <Image
        src={imgUrl?.fileUrl || '/assets/images/products/iphone-xi.png'}
        size={140}
        display="block"
        alt={name}
      />
      <FlexBox
        className="product-details"
        flexDirection="column"
        justifyContent="space-between"
        minWidth="0px"
        width="100%"
      >
        <Link href={`/product/${id}`}>
          <a>
            <Typography className="title" fontWeight="600" fontSize="18px" mb="0.5rem">
              {name}
            </Typography>
          </a>
        </Link>
        <Box position="absolute" right="1rem" top="1rem">
          <IconButton
            padding="4px"
            ml="12px"
            size="small"
            onClick={() => {
              removeItemFromCart(id);
            }}
          >
            <Icon size="1.25rem">close</Icon>
          </IconButton>
        </Box>

        <FlexBox
          // width="100%"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <FlexBox flexWrap="wrap" alignItems="center">
            <Typography color="gray.600" mr="0.5rem">
              MYR{(price * 1).toFixed(2)} x {qty}
            </Typography>
            <Typography fontWeight={600} color="teakita.main" mr="1rem">
              MYR{(price * qty).toFixed(2)}
            </Typography>
          </FlexBox>

          <FlexBox alignItems="center">
            <Button
              variant="outlined"
              color="teakita"
              padding="5px"
              size="none"
              borderColor="teakita.light"
              onClick={qty > 0 ? handleCartAmountChange(qty - 1) : handleCartAmountChange(0)}
            >
              <Icon variant="small">minus</Icon>
            </Button>
            <Typography mx="0.5rem" fontWeight="600" fontSize="15px">
              {qty}
            </Typography>
            <Button
              variant="outlined"
              color="teakita"
              padding="5px"
              size="none"
              borderColor="teakita.light"
              onClick={handleCartAmountChange(qty + 1)}
            >
              <Icon variant="small">plus</Icon>
            </Button>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </StyledProductCard7>
  );
};

export default ProductCard7;
